var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "message" } }, [
    _vm.message
      ? _c("section", { staticClass: "msg-wrapper txt" }, [
          _vm._v(" " + _vm._s(_vm.message) + " "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }